import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import { ProductVm } from 'api/catalog/product.vm';
import { getProducts } from 'api/catalog/get-products';
import { useSnackbar } from 'hooks/use-snackbar';

interface AsrsProductSelectionDialogProps {
  open: boolean;
  onClose: () => void;
  onProductSelect: (productId: string) => void;
}

export const AsrsProductSelectionDialog = ({ open, onClose, onProductSelect }: AsrsProductSelectionDialogProps) => {
  const [availableProducts, setAvailableProducts] = useState<ProductVm[]>([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearchLoading(true);
    getProducts('', searchTerm, {
      success: (response) => {
        setAvailableProducts(response.objects);
        setSearchLoading(false);
      },
      error: (err) => {
        console.error('Falha ao pesquisar produtos:', err);
        snackbar.show('Falha ao pesquisar produtos', null, 'error');
        setSearchLoading(false);
      },
    });
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Adicionar Produtos ao Servidor</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Pesquisar produtos por SKU ou nome"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ mr: 2 }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <Button variant="contained" sx={{ height: '100%' }} startIcon={<Search />} onClick={handleSearch} disabled={searchLoading}>
            Pesquisar
          </Button>
        </Box>

        {searchLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>SKU</TableCell>
                  <TableCell>Nome</TableCell>
                  <TableCell>Unidade de Medida</TableCell>
                  <TableCell align="right">Ações</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {availableProducts.map((product) => (
                  <TableRow key={product.id} hover>
                    <TableCell>{product.sku}</TableCell>
                    <TableCell>{product.name}</TableCell>
                    <TableCell>{product.measureUnitAcronym}</TableCell>
                    <TableCell align="right">
                      <Button
                        size="small"
                        variant="contained"
                        onClick={() => {
                          onProductSelect(product.id);
                        }}
                      >
                        Adicionar
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};
